import { Flex, Icon, Text } from '@chakra-ui/react'
import React from 'react'
import IconTranscripts from '~/assets/svgs/icon-transcripts.svg?react'
import { textStyleKeys } from '~/themes/textStyles'

const ProcessingPlaceholder = ({ isInTab }: { isInTab: boolean }) => (
  <Flex
    paddingTop={isInTab ? '2rem' : '0'}
    direction="column"
    align="center"
    justify="center"
    height="full"
    gap="0.5rem"
    textAlign="center"
  >
    <Icon
      as={IconTranscripts}
      boxSize={isInTab ? '4.45rem' : '1.55rem'}
      sx={{ color: 'gray.700', strokeWidth: '1px' }}
      paddingBottom={isInTab ? '1rem' : '0'}
    />
    <Text textStyle={textStyleKeys.Body1_Bold} color="gray.800">
      Processing call transcription...
    </Text>
    <Text textStyle={textStyleKeys.Body2} color="gray.700">
      This may take several minutes
    </Text>
  </Flex>
)

export default ProcessingPlaceholder
